import pvideo from '@/assets/pc-video-es.mp4'
import mvideo from '@/assets/m-video-es.mp4'
import mcover from '@/assets/img/m-videocover-es.png'

// 音频
import radio1 from '@/assets/radio1.mp3'
import radio2 from '@/assets/radio2.mp3'
import radio3 from '@/assets/radio3.mp3'
import radio4 from '@/assets/radio4.mp3'
import radio5 from '@/assets/radio5.mp3'
import radio6 from '@/assets/radio6.mp3'
import radio7 from '@/assets/radio7.mp3'
import radio8 from '@/assets/radio8.mp3'
import radio9 from '@/assets/radio9.mp3'
import radio10 from '@/assets/radio10.mp3'
import radio11 from '@/assets/radio11.mp3'
import radio12 from '@/assets/radio12.mp3'
import radio13 from '@/assets/radio13.mp3'
import radio14 from '@/assets/radio14.mp3'
import radio15 from '@/assets/radio15.mp3'
import radio16 from '@/assets/radio16.mp3'
import radio17 from '@/assets/radio17.mp3'
import radio18 from '@/assets/radio18.mp3'

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

// 通栏video
export const videoBanner = {
  src: isMobile() ? mvideo : pvideo,
  cover: isMobile() ? mcover : '',
  buttons: [
    {
      name: 'Inglés',
      link: ' https://radio.cgtn.com/special/Stories-of-Xi-Jinping'
    },
    {
      name: 'Español',
      link: 'https://espanol.cgtn.com/event/2023/Historias-de-Xi-Jinping/index.html'
    },
    {
      name: 'Francés',
      link: 'https://radio.cgtn.com/podcast/column/other/Xi-Jinping-son-histoire/611'
    },
    {
      name: 'Árabe',
      link: 'https://radio.cgtn.com/podcast/column/other/radio-cgtn/609'
    },
    {
      name: 'Ruso',
      link: 'https://russian.cgtn.com/event/2023/Stories-of-Xi-Jinping/index.html'
    }
  ]
}

// 轮播及文字列表
export const swipeBanner = [
  // 11月18日新增三个 (要排到前面 readio顺序从13开始继续记)
  {
    title: 'Hacer la tarta más grande y repartirla equitativamente',
    content: 'A finales de 2020, ocho años después de que Xi Jinping asumiera el liderazgo de China, el país logró erradicar la pobreza absoluta en el plazo previsto. Bajo su dirección, la economía china ha pasado de una etapa de rápido crecimiento a otra enfocada en un desarrollo de alta calidad. En este episodio, analizamos cómo China amplía el "pastel" de la riqueza social y asegura su distribución justa y equitativa, para que la población sienta un verdadero progreso en sus vidas.',
    radioUrl: radio13,
    link: 'https://espanol.cgtn.com/news/2024-11-11/1855820620289638402/index.html'
  },
  {
    title: 'El desarrollo ecológico es la base del desarrollo de alta calidad',
    content: '“Si la humanidad no le falla a la naturaleza, la naturaleza no nos fallará a nosotros”. En opinión de Xi Jinping, la continua dedicación de China a la conservación ecológica y la protección ambiental impulsa su camino hacia un crecimiento de alta calidad. En este episodio, exploramos cómo Xi Jinping ha liderado la transformación ecológica de China en su camino hacia la modernización, y cómo ese desarrollo ha mejorado el medio ambiente y generado beneficios tangibles para la población.',
    radioUrl: radio14,
    link: 'https://espanol.cgtn.com/news/2024-11-13/1856534510444863490/index.html'
  },
  {
    title: 'La cultura es la raíz y el alma de una nación',
    content: '“¡Lo tradicional también está de moda!”. Desde la preservación de la Gran Muralla hasta el renovado interés del mercado en los antiguos bordados étnicos, Xi Jinping siente una gran pasión por promover el legado cultural de China mientras trabaja para fomentar el diálogo y el crecimiento mutuo entre naciones y civilizaciones. Para él, la cultura merece ser preservada y compartida. En este episodio, destacamos el compromiso de Xi Jinping en promover los intercambios culturales entre China y la comunidad global.',
    radioUrl: radio15,
    link: 'https://espanol.cgtn.com/news/2024-11-15/1857237162428563457/index.html '
  },
  {
    title: 'Promover la gobernanza basada en la ley para proteger los derechos e intereses del pueblo',
    content: '100-1=0” es una fórmula propuesta por Xi Jinping para enfatizar la importancia del imperio de la ley. El líder chino considera que una sola condena injusta puede arruinar la reputación construida a lo largo de 99 juicios justos. En este episodio, compartimos ejemplos del enfoque de China centrado en las personas y en la gobernanza basada en la ley, así como el compromiso del país con el imperio de la ley a nivel internacional bajo el liderazgo de Xi.',
    radioUrl: radio16,
    link: 'https://espanol.cgtn.com/news/2024-11-18/1856974576174620674/index.html'
  },
  {
    title: 'Solo aquellos que son capaces de pelear pueden detener una pelea',
    content: 'En un mundo de turbulencias y conflictos crecientes, Xi Jinping afirma que disfrutar de la paz es una bendición para el pueblo, y defender la paz es responsabilidad del ejército chino. Como tal, China siempre se adherirá a la construcción de un país próspero defendido por un ejército fuerte.Este episodio destaca la perspectiva de Xi Jinping sobre las responsabilidades del Ejército Popular de Liberación (EPL) de China en la defensa de la nación, la protección de su pueblo y la contribución de China a la paz mundial.',
    radioUrl: radio17,
    link: 'https://espanol.cgtn.com/news/2024-11-20/1859053287730675713/index.html'
  },
  {
    title: 'Asumir juntos la responsabilidad de nuestros tiempos',
    content: 'En este episodio, se destaca el papel de Xi Jinping como "máximo diplomático" de China. A través de diversas historias, se ilustra su esfuerzo por fortalecer las relaciones internacionales y ampliar el “círculo de amigos”del país. Asimismo, se exploran sus ideas sobre gobernanza global y cómo estas han generado cambios tangibles en un mundo inmerso en profundas transformaciones.',
    radioUrl: radio18,
    link: 'https://espanol.cgtn.com/news/2024-11-22/1858709795108126721/index.html'
  },
  // 11月18号以前的
  {
    title: 'El estratega',
    content: 'A lo largo de las décadas en las que Xi Jinping ha desempeñado diversos cargos gubernamentales en China, su enfoque siempre ha estado orientado hacia el futuro. En este episodio, exploraremos las historias que revelan el pensamiento estratégico de Xi Jinping en el ámbito del desarrollo económico y social, y cómo se llevaron a cabo rigurosamente los planes hasta su plena realización.',
    radioUrl: radio1,
    link: 'https://espanol.cgtn.com/news/2023-07-12/1679029856531136513/index.html'
  },
  {
    title: 'Determinación en la respuesta a epidemias',
    content: 'Como dice un antiguo refrán chino: “no se conoce el reto de una tarea hasta que uno mismo la realiza”. Cada paso en la lucha de China contra la COVID-19 en los últimos tres años ha puesto a prueba la sabiduría y el coraje de Xi Jinping, máximo responsable político de un país de más de 1400 millones de habitantes.En este episodio, conoceremos historias sobre las decisiones de Xi Jinping a la hora de hacer frente a grandes emergencias de salud pública como el SARS y la COVID-19, y cómo orientó y optimizó las medidas de prevención contra epidemias para equilibrar el bienestar de la población y el desarrollo económico.',
    radioUrl: radio2,
    link: 'https://espanol.cgtn.com/news/2023-07-12/1679034482273828865/index.html'
  },
  {
    title: 'Un líder en la lucha contra la pobreza',
    content: 'Para fines de 2020, China logró cumplir su objetivo de sacar de la pobreza absoluta a casi 99 millones de residentes rurales empobrecidos, ganando la batalla dentro del plazo previsto. Superar este desafío significativo ha sido un testimonio impresionante de la habilidad de Xi Jinping para abordar y resolver problemas del mundo real. En este episodio, exploraremos cautivadoras historias que destacan cómo Xi Jinping enfrentó obstáculo tras obstáculo para sacar al pueblo chino de la pobreza.',
    radioUrl: radio3,
    link: 'https://espanol.cgtn.com/news/2023-07-17/1680757438421471234/index.html'
  },
  {
    title: 'Responsabilidad frente a las generaciones futuras',
    content: 'Mientras China busca su propio modelo de modernización, el presidente Xi Jinping afirma que China dará prioridad a la protección del medio ambiente y promoverá estilos de vida ecológicos para garantizar el desarrollo sostenible, creando un futuro mejor para todos. En este episodio, exploraremos cómo Xi Jinping planifica y actualiza la construcción de la armonía entre la humanidad y la naturaleza y cómo sus pensamientos sobre la "civilización ecológica" fueron tomando forma.',
    radioUrl: radio4,
    link: 'https://espanol.cgtn.com/news/2023-07-24/1682279858865246209/index.html'
  },
  {
    title: 'Dejar de lado mi propio bienestar por el bien de mi pueblo',
    content: 'Mientras trabajaba en distintas localidades, Xi Jinping viajó mucho para realizar investigaciones en profundidad y estudios sobre el terreno, a fin de conocer mejor las condiciones de vida reales de la gente a nivel de base y formular mejores soluciones para resolver sus problemas. En este episodio, seguiremos los pasos de Xi Jinping en la realización de investigaciones sobre el terreno, y descubriremos cómo ha estado a la altura de la confianza y las expectativas de la gente.',
    radioUrl: radio5,
    link: 'https://espanol.cgtn.com/news/2023-07-31/1684811988816171010/index.html'
  },
  {
    title: 'La innovación como motor principal de desarrollo',
    content: 'En el proceso de transición de la economía china de un rápido crecimiento a un desarrollo de alta calidad, Xi Jinping destaca que la innovación seguirá siendo el epicentro del impulso hacia la modernización del país. Durante mucho tiempo, ha mostrado preocupación por los "cuellos de botella" en sectores clave y ha impulsado la investigación básica para alcanzar la autosuficiencia en ciencia y tecnología. Además, reconoce el valor del talento como el recurso principal para el crecimiento. En este episodio, exploraremos la sólida creencia de Xi Jinping en el poder de la innovación y cómo ha unido fuerzas para llevar a China hacia una mayor autosuficiencia científica y tecnológica. ',
    radioUrl: radio6,
    link: 'https://espanol.cgtn.com/news/2023-08-07/1687375834334117889/index.html'
  },
  {
    title: 'Atraer a las mentes más brillantes',
    content: '¿Qué tipo de personas se consideran grandes talentos? A ojos de Xi Jinping, el abanico puede ser muy amplio, incluyendo a personas con profundos conocimientos y gran sentido de la responsabilidad, así como individuos con habilidades excepcionales, especializadas o poco comunes. Xi ha enfatizado reiteradamente la importancia de ampliar la reserva de talentos y de brindarles amplias plataformas de desarrollo. En este episodio, conoceremos la filosofía de Xi Jinping con respecto al talento y cuánto valora a las personas talentosas en el desarrollo de China.',
    radioUrl: radio7,
    link: 'https://espanol.cgtn.com/news/2023-08-14/1689559877488545793/index.html'
  },
  {
    title: 'Resolver las diferencias mediante el diálogo',
    content: 'Si analizamos las décadas de carrera política de Xi Jinping, queda claro que trabajar con diferentes grupos de interés y diversas perspectivas siempre ha sido un componente fundamental de su labor. A lo largo de los años, ha demostrado una habilidad excepcional en la comunicación y coordinación con una amplia gama de partidos políticos, organizaciones sociales, grupos étnicos y personas de diversos orígenes. En este episodio, exploraremos cómo Xi Jinping ha logrado establecer una comunicación eficaz con todas las partes involucradas, con el fin de forjar un esfuerzo concertado para materializar el sueño chino.',
    radioUrl: radio8,
    link: 'https://espanol.cgtn.com/news/2023-08-21/1691717579786489857/index.html'
  },
  {
    title: 'La confianza del pueblo es mi mayor motivación',
    content: 'A lo largo de varias décadas, Xi Jinping pasó de ser un joven funcionario local a liderar la nación china, pero su devoción por el pueblo nunca ha cambiado. Para Xi, “poner a la gente en primer lugar” significa tomar medidas para priorizar al pueblo. En este episodio, conoceremos cómo Xi Jinping se ganó la confianza y el respeto de la gente, lo cual dio una mayor fuerza y una gran motivación al pueblo chino para seguir adelante.',
    radioUrl: radio9,
    link: 'https://espanol.cgtn.com/news/2023-08-28/1696084799997886465/index.html'
  },
  {
    title: 'Mantener una visión global en la resolución de problemas comunes',
    content: 'Frente a un mundo en constante cambio y lleno de desafíos, surgen innumerables dudas y expectativas desde diversas regiones sobre si China mantendrá su política de apertura y compartirá más oportunidades de desarrollo con el mundo. La respuesta de Xi Jinping es enfáticamente afirmativa. En este episodio, exploraremos el entusiasmo con el que Xi Jinping impulsa el intercambio y la cooperación internacional, lo que nos permitirá comprender más a fondo su visión global y su perspectiva sobre la relación de China con el resto del mundo.',
    radioUrl: radio10,
    link: 'https://espanol.cgtn.com/news/2023-09-04/1697459749667577858/index.html'
  },
  {
    title: 'Me considero un hombre común',
    content: 'A lo largo de los años, Xi Jinping se ha convertido en un modelo que honra la sencillez y la frugalidad en la vida y la diligencia en el trabajo. Independientemente de dónde trabaje, ya sea a nivel local o central, siempre ha insistido en que los funcionarios públicos deben cultivar su carácter y sus virtudes para dar ejemplo de honradez e integridad. En este episodio de "Historias de Xi Jinping", conoceremos historias sobre la vida personal y familiar de Xi Jinping, lo que brindará una visión más cercana de él, no solo como líder, sino como hombre común y corriente.',
    radioUrl: radio11,
    link: 'https://espanol.cgtn.com/news/2023-09-11/1699318377076858882/index.html'
  },
  {
    title: 'La lectura es mi mayor afición',
    content: 'A Xi Jinping le encanta leer y escribir, y es reconocido como un líder con un profundo conocimiento de la literatura. Desde su estancia en la aldea de Liangjiahe hasta sus años de estudio en la Universidad Tsinghua, desde su desempeño como funcionario local hasta su liderazgo a nivel nacional, la lectura ha sido siempre la gran pasión de Xi Jinping y una parte fundamental de su estilo de vida. En este episodio de "Historias de Xi Jinping", conoceremos anécdotas interesantes sobre Xi Jinping como ávido lector y apasionado escritor.',
    radioUrl: radio12,
    link: 'https://espanol.cgtn.com/news/2023-09-18/1703609859004461058/index.html'
  }
]

// big视频列表
import video2 from '@/assets/video2.mp4'
import video3 from '@/assets/video3.mp4'
import video5 from '@/assets/video5.mp4'

import shbg1 from '@/assets/img/sh-bg-1.jpg'
import mshbg1 from '@/assets/img/m-sh-bg-1.jpg'
import shbg2 from '@/assets/img/sh-bg-2.jpg'
import mshbg2 from '@/assets/img/m-sh-bg-2.jpg'

export const bigVideoList = [ // 该数组使用reverse进行翻转
  {
    link: 'https://espanol.cgtn.com/news/2023-10-27/1717733608903716866/index.html',
    bg: isMobile() ? mshbg2 : shbg2,
    cover: require('@/assets/img/sh-5.png'),
    videoSrc: video3,
    title: 'Un exdiplomático chileno elogia el lanzamiento del podcast documental sobre el presidente de China',
    content: 'El lanzamiento mundial de "Historias de Xi Jinping", una serie de 12 episodios en formato podcast, que relatan la vida del presidente de China, ha suscitado reacciones en el mundo. Desde Chile, el exembajador Fernando Reyes Matta, nos compartió sus impresiones sobre el material audiovisual.'
  },
  {
    link: 'https://espanol.cgtn.com/news/2023-10-21/1715667359312670721/index.html',
    bg: isMobile() ? mshbg2 : shbg2,
    cover: require('@/assets/img/sh-3.png'),
    videoSrc: '',
    title: 'Lanzamiento mundial del podcast documental de CGTN "Historias de Xi Jinping"',
    content: 'China Global Television Network (CGTN) presentó el 18 de octubre en la ciudad alemana de Fráncfort su serie de podcasts en varios idiomas "Historias de Xi Jinping", como uno de los productos "El poder del pensamiento" de CGTN, para presentar a la audiencia global una visión más cercana del presidente chino.'
  },
  {
    link: 'https://espanol.cgtn.com/news/2023-08-01/1685933195399282690/index.html',
    bg: isMobile() ? mshbg2 : shbg2,
    cover: require('@/assets/img/sh-4.png'),
    videoSrc: video5,
    title: 'Un hombre de pueblo',
    content: 'Xi Jinping trabajó durante años a nivel de base, por lo que es un líder que proviene del pueblo.'
  },
  {
    link: 'https://espanol.cgtn.com/news/2023-07-31/1685920889999212546/index.html',
    bg: isMobile() ? mshbg1 : shbg1,
    cover: require('@/assets/img/sh-1.png'),
    videoSrc: video2,
    title: 'Un líder en la lucha contra la pobreza',
    content: 'Xi Jinping empezó a trabajar en Fujian en junio de 1985. En ese entonces, la parte oriental de la provincia era la más empobrecida. Xi Jinping visitó durante varios años todas las grandes plantaciones de té de la región para averiguar las principales razones por las que los cultivadores locales no podían ganarse la vida dignamente. Descubrió que, a pesar de contar con unas condiciones naturales favorables, la industria local del té estaba demasiado dispersa y desorganizada, y carecía de buenos proyectos y una industria local próspera.'
  }
]

// small视频列表
export const smallVideoList = [
  {
    bg: isMobile() ? require('@/assets/img/m-sh-bg-3.jpg') : require('@/assets/img/sh-bg-3.jpg'),
    list: [
      {
        cover: isMobile() ? require('@/assets/img/m-sh-8.png') : require('@/assets/img/sh-8.png'),
        videoSrc: 'video1.mp4',
        title: 'Остров Гуланъюй: Охрана культурного наследия',
        link: 'https://russian.cgtn.com/news/2023-07-20/1681882286312812545/index.html'
      },
      {
        cover: isMobile() ? require('@/assets/img/m-sh-3.png') : require('@/assets/img/sh-3.png'),
        videoSrc: video3,
        title: 'Честность и неподкупность',
        link: 'https://russian.cgtn.com/news/2023-07-20/1681883476902748162/index.html'
      },
      {
        cover: isMobile() ? require('@/assets/img/m-sh-4.png') : require('@/assets/img/sh-4.png'),
        videoSrc: 'video4.mp4',
        title: 'На благо народа',
        link: 'https://russian.cgtn.com/news/2023-07-20/1681884094271746049/index.html'
      },
      {
        cover: isMobile() ? require('@/assets/img/m-sh-7.png') : require('@/assets/img/sh-7.png'),
        videoSrc: 'video6.mp4',
        title: 'Реставрация храма Лунсинсы',
        link: 'https://russian.cgtn.com/news/2023-07-20/1681885144797093890/index.html'
      },
    ]
  },
  {
    bg: isMobile() ? require('@/assets/img/m-sh-bg-3.jpg') : require('@/assets/img/sh-bg-4.jpg'),
    list: [
      {
        cover: isMobile() ? require('@/assets/img/m-sh-5.png') : require('@/assets/img/sh-5.png'),
        videoSrc: 'video7.mp4',
        title: 'Важность чтения',
        link: 'https://russian.cgtn.com/news/2023-07-20/1681886630914498561/index.html'
      },
      {
        cover: isMobile() ? require('@/assets/img/m-sh-6.png') : require('@/assets/img/sh-6.png'),
        videoSrc: 'video8.mp4',
        title: 'Кабинет открыт для широкой общественности',
        link: 'https://russian.cgtn.com/news/2023-07-20/1681888541626494977/index.html'
      },
      {
        cover: isMobile() ? require('@/assets/img/m-sh-9.png') : require('@/assets/img/sh-9.png'),
        videoSrc: 'video9.mp4',
        title: 'Способен хорошо выполнять малые дела, делай их с большой любовью',
        link: 'https://russian.cgtn.com/news/2023-07-20/1681890601389465601/index.html'
      },
      {
        cover: isMobile() ? require('@/assets/img/m-sh-10.png') : require('@/assets/img/sh-10.png'),
        videoSrc: 'video10.mp4',
        title: 'По следам Морского шелкового пути',
        link: 'https://russian.cgtn.com/news/2023-07-20/1681891109383598081/index.html'
      },
    ]
  }
]